module.exports = __webpack_public_path__ + "tz.ec5a26d3.svg";